import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";

export const LegalPage = ({ kind }) => {
  const isPrivacy = kind === "privacy";
  const title = isPrivacy ? "Privacy Policy" : "Terms of Service";
  return (
    <>
      <Seo title={`${title} | Kryvo Technologies`} description={`${title} for the Kryvo Technologies website.`} />
      <section className="grid-bg bg-kryvo-mist pb-12 pt-[calc(72px+4rem)]">
        <div className="container-x max-w-3xl">
          <Reveal>
            <h1 className="text-4xl font-semibold text-kryvo-ink sm:text-5xl">{title}</h1>
            <p className="mt-4 text-sm text-kryvo-ink/55">Last updated: July 2026</p>
          </Reveal>
        </div>
      </section>
      <section className="container-x max-w-3xl py-14" data-testid={`legal-${kind}`}>
        {isPrivacy ? (
          <div className="flex flex-col gap-8 text-sm leading-relaxed text-kryvo-ink/70">
            <div>
              <h2 className="mb-2 text-xl font-semibold text-kryvo-ink">What we collect</h2>
              <p>When you submit an enquiry through our contact form, we collect the details you provide: your name, company, email address, phone number, project type and message. We use this information solely to respond to your enquiry.</p>
            </div>
            <div>
              <h2 className="mb-2 text-xl font-semibold text-kryvo-ink">How we use it</h2>
              <p>Your information is used only to communicate with you about your enquiry and related services. We do not sell, rent or share your personal information with third parties for their marketing purposes.</p>
            </div>
            <div>
              <h2 className="mb-2 text-xl font-semibold text-kryvo-ink">Your choices</h2>
              <p>You may ask us at any time to update or delete the information you have shared with us by contacting us through this website.</p>
            </div>
          </div>
        ) : (
          <div className="flex flex-col gap-8 text-sm leading-relaxed text-kryvo-ink/70">
            <div>
              <h2 className="mb-2 text-xl font-semibold text-kryvo-ink">Use of this website</h2>
              <p>The content on this website is provided for general information about Kryvo Technologies, our services and our products. You may browse and share this content for informational purposes.</p>
            </div>
            <div>
              <h2 className="mb-2 text-xl font-semibold text-kryvo-ink">Intellectual property</h2>
              <p>All content, branding and product names on this website — including Kryvo, Kryvo CRM and Kryvo Engage — are the property of Kryvo Technologies and may not be reproduced without permission.</p>
            </div>
            <div>
              <h2 className="mb-2 text-xl font-semibold text-kryvo-ink">No warranties</h2>
              <p>This website is provided "as is" without warranties of any kind. Nothing on this website constitutes a binding offer; any engagement is governed by a separately agreed contract.</p>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default LegalPage;
